module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Kaenerkinden-1350ae2f55e37ceb694c55ac0ef5657d.png";